/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum MeetingLinkType {
  ZOOM = "ZOOM",
  MANUAL = "MANUAL",
}

export const MeetingLinkTypeDisplay: Record<MeetingLinkType, string> = {
  [MeetingLinkType.ZOOM]: "Zoom",
  [MeetingLinkType.MANUAL]: "Manual",
};
